import './lib/outliner';
import defaults from './lib/banner/defaults';
import factory from './lib/banner/factory';
import { composeTypes } from './lib/banner/utils';

export default (opts = {}) => {
    return factory(Object.assign({}, defaults, opts, {
        types: opts.types ? Object.keys(opts.types).reduce(composeTypes(opts), defaults.types) : defaults.types
    }));
};